import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ng-pass',
  templateUrl: './ng-pass.component.html',
  styleUrls: ['./ng-pass.component.scss']
})
export class NgPassComponent implements OnInit {

  constructor(private configurationService: ConfigurationService) { }

  @Input()
  password: string;

  @Output()
  passwordChange = new EventEmitter<string>();


  @Input()
  isValid: boolean;

  @Output()
  isValidChange = new EventEmitter<boolean>();

  @Input()
  minPassword: number = 10;

  @Input()
  maxPassword: number = 16;

  regex: string = this.configurationService.get().PASSWORD_PATTERN;

  @Input()
  submitAttempt: boolean = false;

  showErrors : boolean = true;
  
  hasMinLength() { return this.password?.length >= this.minPassword; }
  hasMaxLength() { return this.password?.length <= this.maxPassword && this.password?.length > 0 }
  hasNumber() { return /\d/.test(this.password) };
  hasUpper() { return /[A-Z]/.test(this.password) && this.password != null && this.password != undefined && this.password.length > 0 };
  hasLower() { return /[a-z]/.test(this.password) && this.password != null && this.password != undefined && this.password.length > 0 };
  hasSpecial() { return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(this.password) };


  ngOnInit(): void {
  }

  checkValidity() {
    this.isValid = this.hasMinLength() && this.hasMaxLength() &&
      (this.hasNumber() ? 1 : 0) + (this.hasUpper() ? 1 : 0) +
      (this.hasLower() ? 1 : 0) + (this.hasSpecial() ? 1 : 0) >= 3;
    this.passwordChange.emit(this.password);
    this.isValidChange.emit(this.isValid);
  }

}
